module.exports = __webpack_public_path__ + "img/bx_bx-rotate-left.d7d107df.svg";